var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [!_vm.winner && _vm.currentRound.steps ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    attrs: {
      "id": "left-side"
    }
  }, [_c('span', {
    class: [_vm.onTablet ? 'pulled' : ''],
    attrs: {
      "id": "left-tube"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.tube)
    }
  }), _vm._l(_vm.side.left, function (word, index) {
    return _c('div', {
      key: ("word-" + index),
      class: {
        container: true,
        isMobile: _vm.onTablet
      },
      attrs: {
        "aria-label": ((word.prefix ? ("prefix " + (word.prefix) + ", ") : '') + "missing vowels" + (word.suffix ? (", suffix " + (word.suffix)) : '')),
        "role": "region"
      }
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(word.prefix)
      }
    }), _c('div', {
      staticClass: "match",
      attrs: {
        "id": ("leftV" + (word.id))
      }
    }), _c('div', {
      domProps: {
        "textContent": _vm._s(word.suffix)
      }
    })]);
  })], 2), _c('div', {
    staticClass: "trampoline"
  }, [_c('text-display-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input,
      expression: "input"
    }],
    attrs: {
      "element": "div",
      "id": "input"
    }
  }, [_c('blinking-cursor-text', {
    class: 'step step-' + _vm.progress.stepIndex,
    attrs: {
      "text": _vm.currentStep.vowels,
      "text-step": _vm.progress.stepIndex
    }
  })], 1), _c('figure', {
    attrs: {
      "id": "trampoline-figure"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.trampoline)
    }
  })], 1), _c('div', {
    attrs: {
      "id": "right-side"
    }
  }, [_c('span', {
    class: [_vm.onTablet ? 'pulled' : ''],
    attrs: {
      "id": "right-tube"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.tube)
    }
  }), _vm._l(_vm.side.right, function (word, index) {
    return _c('div', {
      key: ("word-" + index),
      class: {
        container: true,
        isMobile: _vm.onTablet
      },
      attrs: {
        "aria-label": ((word.prefix ? ("prefix " + (word.prefix) + ", ") : '') + "missing vowels" + (word.suffix ? (", suffix " + (word.suffix)) : '')),
        "role": "region"
      }
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(word.prefix)
      }
    }), _c('div', {
      staticClass: "match",
      attrs: {
        "id": ("rightV" + (word.id))
      }
    }), _c('div', {
      domProps: {
        "textContent": _vm._s(word.suffix)
      }
    })]);
  })], 2)]) : _c('div', {
    attrs: {
      "id": "winner"
    }
  }, [_c('figure', [_c('div', {
    attrs: {
      "id": "medal"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.medal)
    }
  }), _c('figcaption', [_vm._v("\n            " + _vm._s(_vm.winner) + "\n            "), _c('br'), _vm._v("WINS\n          ")])])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }